import { EModeMesure } from "../Shared/enum/mode-mesure";
import { LargeurStation } from "./largeur-station";

export class MesureStation {
    LpbMoyenne: number;
    LmMoyenne: number;
    LongueurStation: number;
    Smouillee: number;
    LmaxZoneBerge: number;
    ProfondeurLimiteZiZp: number;
    LtReelle: number;
    ModeMesure: EModeMesure;
    LargeurStations: LargeurStation[] = [];

    static mapFromJSON(json): MesureStation {
        const ms = new MesureStation();

        ms.LpbMoyenne = json.lpbMoyenne;
        ms.LmMoyenne = json.lmMoyenne;
        ms.LongueurStation = json.longueurStation;
        ms.Smouillee = json.sMouillee;
        ms.LmaxZoneBerge = json.lMaxZoneBerge;
        ms.ProfondeurLimiteZiZp = json.profondeurLimiteZiZp;
        ms.LtReelle = json.ltReelle;
        ms.ModeMesure = json.modeMesure;
        
        if (json.largeurStations) {
            ms.LargeurStations = json.largeurStations.map(jsonItem => LargeurStation.mapFromJSON(jsonItem));
        }
        return ms;
    }
}